import { render, staticRenderFns } from "./ArtistViewPage.vue?vue&type=template&id=f8da634a&scoped=true&"
import script from "./ArtistViewPage.vue?vue&type=script&lang=js&"
export * from "./ArtistViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ArtistViewPage.vue?vue&type=style&index=0&id=f8da634a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8da634a",
  null
  
)

export default component.exports